import React from 'react';
import NotFoundIcon from '../assets/images/page-not-found.png';

const PageNotFound = () => {
  return (
    <div className="container p-4">
      <p className="text-center">
        Sorry, the Issue / Request you are looking for wasn’t found. Please try again later or contact customer support.
      </p>
      <p className="text-center">
        <img width="200" height="200" alt="Page not found icon" src={NotFoundIcon}/>
      </p>
    </div>
  )
};

export default PageNotFound;